import {USER_REQUEST, USER_ERROR, USER_SUCCESS} from "../actions/user";
import apiCall from "../../utils/api";
import {AUTH_LOGOUT} from "../actions/auth";

const state = {status: "", profile: {}};

const getters = {
    getProfile: state => state.profile,
    isProfileLoaded: state => !!state.profile.name,
    isStaff: state => state.profile['is_staff'] === true || state.profile['is_superuser'] === true
};

const actions = {
    [USER_REQUEST]: ({commit, dispatch}) => {
        commit(USER_REQUEST);
        return new Promise((resolve) => {
            apiCall.getUser()
                .then(resp => {
                    commit(USER_SUCCESS, resp);
                    resolve(resp);
                })
                .catch(err => {
                    if (err.request.status === 401) {
                        // if resp is unauthorized, logout
                        dispatch(AUTH_LOGOUT);
                    }

                    console.log("ERROR getting user info");
                    commit(USER_ERROR);
                });
        });
    }
};

const mutations = {
    [USER_REQUEST]: state => {
        state.status = "loading";
    },
    [USER_SUCCESS]: (state, resp) => {
        state.status = "success";
        state.profile = resp.data;
    },
    [USER_ERROR]: state => {
        state.status = "error";
    },
    [AUTH_LOGOUT]: state => {
        state.profile = {};
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};